import { from as observableFrom, Observable, switchMap, ObservableInput } from 'rxjs';
import { Injectable } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { leaseAgreementCommand, LeaseAgreementMultiselectCommand } from '../../command/lease-agreement.command';
import { Router } from '@angular/router';
import { ComponentMessageDispatcher } from '../../../core/service/component-message-dispather.service';
import { Location } from '@angular/common';
import { rentalObjectCommand, RentalObjectMultiselectCommand } from '../../command/rental-object.command';
import { OtherRentalObjectService } from './../../service/data/other-rental-object.service';
import { RentalObjectFilteredCommand } from '../../command/rental-object-filtered.command';
import { RentalObjectCategory } from '../../model/const/enums';
import { DwellingService } from '../data/dwelling.service';
import { PremisesService } from '../data/premises.service';
import { ParkingService } from '../data/parking.service';
import { RentalObjectService } from '../base/rental-object';

@Injectable()
export class FeeChangeCommandHandler implements ICommandHandler {
  constructor(
    private _router: Router,
    private _location: Location,
    private _messageDispatcher: ComponentMessageDispatcher,
    private _otherRentalObjectDataService: OtherRentalObjectService,
    private _dwellingService: DwellingService,
    private _premisesService: PremisesService,
    private _parkingService: ParkingService
  ) {
    this.serviceMap = {
      [RentalObjectCategory.Other]: this._otherRentalObjectDataService,
      [RentalObjectCategory.Dwelling]: this._dwellingService,
      [RentalObjectCategory.Premises]: this._premisesService,
      [RentalObjectCategory.Parking]: this._parkingService,
    };
  }

  private serviceMap: Record<RentalObjectCategory, RentalObjectService<any>>;

  canExecute(command: CommandBase): boolean {
    if (command instanceof FilteredCommand) {
      return command.id === rentalObjectCommand.feeChange && command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof RentalObjectFilteredCommand) {
      const service = this.serviceMap[command.category];
      if (service) {
        return service
          .getIdsByFilter(command.includedIds, command.excludedIds, command.filterProvider)
          .pipe(switchMap(result => this.navigateToRentalChanges(command.category, result)));
      }
    }
  }

  private navigateToRentalChanges(category: RentalObjectCategory, ids: string[]): ObservableInput<any> {
    return this._router.navigate([`${this._location.path()}/rental-changes`]).then(result => {
      if (result) {
        this._messageDispatcher.send({ category: category, rentalObjects: ids });
      }
    });
  }
}
